import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { addDataLayerGAEvent } from '@utils/DataLayerGAHandler';

import CitySelector from '../../../../common/components/CitySelector';

import './FindYourHome.scss';

const FindYourHome = ({ cityList }) => {
  const handleSearchBtn = () => {
    addDataLayerGAEvent('Tenant', 'clickBtn', 'findYourHomeBtn');
  };

  return (
    <section className="find-your-home__container">
      <h2 className="find-your-home__title">
        {trans('home.tenant.find-your-home.title')}
      </h2>
      <CitySelector
        onClick={handleSearchBtn}
        cities={cityList}
        className="find-your-home__city-selector"
      />
    </section>
  );
};

FindYourHome.propTypes = {
  cityList: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default FindYourHome;
